import { useEffect, useState } from "react";

const DEFAULT_MIN_DELAY_MS = 5000;
const DEFAULT_MAX_WAIT_MS = 12000;

/**
 * Bloquea el CTA hasta que el vídeo del avatar haya empezado a reproducirse
 * y haya transcurrido un mínimo de tiempo (p. ej. mientras carga el asset).
 */
export function useVideoContinueGate(
	videoRef,
	{ minDelayMs = DEFAULT_MIN_DELAY_MS, maxWaitMs = DEFAULT_MAX_WAIT_MS } = {},
) {
	const [canContinue, setCanContinue] = useState(false);

	useEffect(() => {
		const video = videoRef.current;
		if (!video) return;

		let minDelayTimer = null;
		let maxWaitTimer = null;
		let playbackStarted = false;

		const clearTimers = () => {
			if (minDelayTimer) window.clearTimeout(minDelayTimer);
			if (maxWaitTimer) window.clearTimeout(maxWaitTimer);
			minDelayTimer = null;
			maxWaitTimer = null;
		};

		const unlockContinue = () => {
			setCanContinue(true);
			clearTimers();
		};

		const onPlaybackStart = () => {
			if (playbackStarted) return;
			playbackStarted = true;
			minDelayTimer = window.setTimeout(unlockContinue, minDelayMs);
		};

		const onPlaying = () => onPlaybackStart();

		const onTimeUpdate = () => {
			if (video.currentTime > 0.05) onPlaybackStart();
		};

		video.addEventListener("playing", onPlaying);
		video.addEventListener("timeupdate", onTimeUpdate);

		if (!video.paused && !video.ended && video.currentTime > 0) {
			onPlaybackStart();
		}

		maxWaitTimer = window.setTimeout(unlockContinue, maxWaitMs);

		return () => {
			video.removeEventListener("playing", onPlaying);
			video.removeEventListener("timeupdate", onTimeUpdate);
			clearTimers();
			setCanContinue(false);
		};
	}, [videoRef, minDelayMs, maxWaitMs]);

	return canContinue;
}
